<div class="overlay">
  <div class="simple-popup">
    <img (click)="close()" src="assets/img/artists-settings/cross.svg" />
    <div>
      <h1>{{ title }}</h1>
      <p> {{ message }} </p>
    </div>
    <button class="landing-button" (click)="close()">{{ buttonText }}</button>
  </div>
</div>
